import { jsx as _jsx } from "react/jsx-runtime";
import { PrismCodeBlock } from "../PrismCodeBlock.js";
const langMap = new Map([["js", "javascript"]]);
export function CodeBlock({ lang, children, code, }) {
    lang = lang ? langMap.get(lang) || lang : undefined;
    code = code || (typeof children === "string" ? children : undefined);
    return _jsx(PrismCodeBlock, { language: lang, code: code });
}
